import React from 'react';

const SodaIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <rect
      x="20"
      y="16"
      width="24"
      height="36"
      rx="8"
      fill="#b2ebf2"
      stroke="#0097a7"
      strokeWidth="2"
    />
    <rect
      x="26"
      y="8"
      width="12"
      height="10"
      rx="3"
      fill="#80deea"
      stroke="#0097a7"
      strokeWidth="1"
    />
    <circle cx="32" cy="40" r="3" fill="#fff" opacity="0.7" />
    <circle cx="32" cy="48" r="2" fill="#fff" opacity="0.5" />
    <circle cx="32" cy="32" r="2" fill="#fff" opacity="0.5" />
  </svg>
);

export default SodaIcon;
